import BaseState from 'Engine/base/states/BaseState';
import GlobalDispatcher from '../libs/game-engine/src/events/GlobalDispatcher';
import eEventTypes from '../enums/eEventTypes';

export default class OpenJackpotBoxesState extends BaseState {

  addListeners() {
    super.addListeners();
    GlobalDispatcher.add(eEventTypes.EET_OPEN_JACKPOT_BOXES__COMPLETE, this.complete.bind(this));
  }

  complete() {
    if (this.active) {
      super.complete();
    }
  }
}
